function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './FeatureSection.module.scss';
import { Anchor, Container, SimpleGrid, Text, Title } from '@mantine/core';
import Panel from '../Panel';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { WebRoutes } from '@/utils/constants';
import ChatFilterPanels from './ChatFilterPanels';
import ChatInteractionPanel from './ChatInteractionPanel';
import ScheduledAnnouncementPanel from './ScheduledAnnouncement';
import classNames from 'classnames';
import IntegrationPanel from './IntegrationPanel';
function FeaturePanel(param) {
    var title = param.title, description = param.description, children = param.children, anchorProps = param.anchorProps;
    return /*#__PURE__*/ _jsxs(Panel, {
        className: styles.featurePanel,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.featurePanelContent,
                children: children
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.featurePanelInfo,
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        order: 2,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        c: "dimmed",
                        children: description
                    })
                ]
            })
        ]
    });
}
function FeaturePanels(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var intl = useIntl();
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.featureSectionContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, _object_spread_props(_object_spread({
            size: "xl"
        }, props), {
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    className: styles.title,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "UjD3+2",
                        defaultMessage: "Refined Essentials"
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    size: "xl",
                    c: "dimmed",
                    className: styles.description,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "p3nSIv",
                        defaultMessage: "Nightbot can do the heavy lifting for you. So you can focus on what matters most to you. <link>Learn more</link>.",
                        values: {
                            link: function(chunks) {
                                return /*#__PURE__*/ _jsx(Anchor, {
                                    component: Link,
                                    to: WebRoutes.DASHBOARD,
                                    children: chunks
                                });
                            }
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs(SimpleGrid, {
                    className: styles.featurePanels,
                    cols: {
                        base: 1,
                        sm: 2
                    },
                    spacing: "lg",
                    children: [
                        /*#__PURE__*/ _jsx(FeaturePanel, {
                            title: intl.formatMessage({
                                id: "qg6hHs",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Real-time Chat Interaction"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "sZ5WUP",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Tired of repeating yourself? Link a message to a command and let Nightbot respond for you."
                                    }
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(ChatInteractionPanel, {
                                className: styles.chatInteractionPanel
                            })
                        }),
                        /*#__PURE__*/ _jsx(FeaturePanel, {
                            title: intl.formatMessage({
                                id: "wcj1yy",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Automatic Moderation"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "2ywgY0",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Remove many kinds of spam automatically with advanced chat filters, and keep your chat clean and safe."
                                    }
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(ChatFilterPanels, {
                                className: styles.chatFilterPanel
                            })
                        }),
                        /*#__PURE__*/ _jsx(FeaturePanel, {
                            title: intl.formatMessage({
                                id: "q6kDxp",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Scheduled Announcements"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "zLQmca",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Schedule messages to be sent at specific intervals, so you can keep your audience informed."
                                    }
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(ScheduledAnnouncementPanel, {
                                className: styles.scheduledAnnouncementPanel
                            })
                        }),
                        /*#__PURE__*/ _jsx(FeaturePanel, {
                            title: intl.formatMessage({
                                id: "X1C3Hh",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Same Bot, Any Platform"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "es/ZNJ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Integrate with your favorite platforms and services, and let Nightbot do the work for you."
                                    }
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(IntegrationPanel, {
                                className: styles.integrationPanel
                            })
                        })
                    ]
                })
            ]
        }))
    }));
}
export default FeaturePanels;
